import * as actionTypes from "./actionTypes";
import axios from "../../axios";
import { API } from "../../constants";

export const setOpeningHours = (openingHours) => {
  return {
    type: actionTypes.SET_OPENINGHOURS,
    openingHours,
  };
};

export const setOpeningHoursLoading = () => {
  return {
    type: actionTypes.FETCH_OPENINGHOURS,
  };
};

export const setOpeningHoursFailed = (error = true) => {
  return {
    type: actionTypes.FETCH_OPENINGHOURS_FAILED,
    error,
  };
};

export const updateOpeningHourStatus = (storageId, status) => {
  return {
    type: actionTypes.UPDATE_OPENINGHOURS_STATUS,
    storageId,
    status,
  };
};

export const initOpeningHours = () => {
  return (dispatch) => {
    dispatch(setOpeningHoursLoading());

    axios
      .get(`${API}en/angel/opening-hours/status`)
      .then((response) => {
        dispatch(setOpeningHours(response.data ? response.data : []));
      })
      .catch((error) => {
        console.error("err openingHours:", error);
        dispatch(setOpeningHoursFailed(error?.request?.status || true));
      });
  };
};

export const submitOpeningHourStatus = (storageId, status, times = null) => {
  return (dispatch) => {
    axios
      .post(`${API}en/angel/opening-hours/status`, {
        storageId,
        status,
        times,
      })
      .then((response) => {
        dispatch(updateOpeningHourStatus(storageId, status));
      })
      .catch((error) => {
        console.error("err submitting opening hour status:", error);
      });
  };
};
